// extracted by mini-css-extract-plugin
export default {"container":"outputText_container__j3MHF","contentBox":"outputText_contentBox__8qE7V"};